"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_LINT_FORBIDDEN_PROPERTIES = exports.APP_BASE_LINT_FORBIDDEN_SELECTORS = exports.APP_BASE_CSS_VARS = exports.APP_BASE_FIELD_TYPE_ATTR = exports.APP_BASE_FIELD_ATTR = exports.APP_BASE_ROLE_ATTR = exports.APP_BASE_STATE_VALUES = exports.APP_BASE_STATE_ATTR = exports.APP_BASE_FLAG_ATTRS = exports.APP_BASE_COMPONENT_ID_VALUES = exports.APP_BASE_COMPONENT_IDS = exports.APP_BASE_SHELL_ROLE_IDS = exports.APP_BASE_COMPONENT_ATTR = exports.APP_BASE_ROOT_ATTRS = exports.APP_BASE_MOTION_INDEX_CSS_VAR = exports.APP_BASE_MOTION_CLASS_PREFIX = exports.APP_BASE_SCOPE_CLASS = void 0;
const app_base_design_tokens_1 = require("./app-base-design-tokens");
const motion_css_1 = require("./motion-css");
const view_component_types_1 = require("./view-component-types");
/**
 * sl-8n5m.14.1 / sl-sbpf.1: Stable CSS Contract for AppBases.
 *
 * Single Source of Truth for all stable CSS class names, data-attributes,
 * and CSS custom properties exposed to user-authored CSS.
 *
 * Rule: every AppBase component MUST emit attributes/classes listed here.
 *       user-authored CSS MUST only target selectors derived from this file.
 *
 * Drift policy: adding a new entry is additive (no breaking change).
 *               renaming / removing an entry is a public-API break and
 *               requires a version bump + deprecation window.
 */
exports.APP_BASE_SCOPE_CLASS = motion_css_1.DEFAULT_MOTION_SCOPE_CLASS;
exports.APP_BASE_MOTION_CLASS_PREFIX = motion_css_1.MOTION_CLASS_PREFIX;
exports.APP_BASE_MOTION_INDEX_CSS_VAR = motion_css_1.MOTION_INDEX_CSS_VAR;
exports.APP_BASE_ROOT_ATTRS = {
    appBaseId: 'data-sl-app-id',
    appSlug: 'data-sl-app-slug',
    mode: 'data-sl-mode',
};
/**
 * Attribute carrying the component identifier on every rendered
 * component wrapper and shell region: `data-sl-component="…"`.
 */
exports.APP_BASE_COMPONENT_ATTR = 'data-sl-component';
/**
 * Shell-level region identifiers. These are NOT ViewComponents — they
 * identify layout regions of the published page shell.
 */
exports.APP_BASE_SHELL_ROLE_IDS = {
    shell: 'shell',
    hero: 'hero',
    nav: 'nav',
    search: 'search',
    tags: 'tags',
    pagination: 'pagination',
    form: 'form',
    content: 'content',
    rowDetail: 'row-detail',
    freeComposition: 'free-composition-layer',
};
/**
 * All values emitted on `data-sl-component="…"`.
 *
 * Derived from VIEW_COMPONENT_TYPES: every registered ViewComponent
 * type IS a valid component id — a new component type joins the
 * contract automatically, drift is impossible by construction.
 */
exports.APP_BASE_COMPONENT_IDS = {
    ...exports.APP_BASE_SHELL_ROLE_IDS,
    ...view_component_types_1.VIEW_COMPONENT_TYPES,
};
exports.APP_BASE_COMPONENT_ID_VALUES = Array.from(new Set(Object.values(exports.APP_BASE_COMPONENT_IDS)));
exports.APP_BASE_FLAG_ATTRS = {
    hero: 'data-sl-flag-hero',
    search: 'data-sl-flag-search',
    tags: 'data-sl-flag-tags',
    form: 'data-sl-flag-form',
    nav: 'data-sl-flag-nav',
    pagination: 'data-sl-flag-pagination',
};
exports.APP_BASE_STATE_ATTR = 'data-sl-state';
exports.APP_BASE_STATE_VALUES = {
    loading: 'loading',
    empty: 'empty',
    error: 'error',
    missingBinding: 'missing-binding',
    unavailable: 'unavailable',
    selected: 'selected',
    hovered: 'hovered',
};
exports.APP_BASE_ROLE_ATTR = 'data-sl-role';
exports.APP_BASE_FIELD_ATTR = 'data-sl-field';
exports.APP_BASE_FIELD_TYPE_ATTR = 'data-sl-field-type';
exports.APP_BASE_CSS_VARS = Object.freeze(Object.keys(app_base_design_tokens_1.APP_BASE_DESIGN_BASELINE_TOKENS));
exports.APP_BASE_LINT_FORBIDDEN_SELECTORS = ['.affine-', '._'];
exports.APP_BASE_LINT_FORBIDDEN_PROPERTIES = ['!important'];
